import { Injectable } from '@angular/core';

@Injectable()
export class ShareService {

    //サービス起動時に、コンストラクタで利用するものをインスタンス化
    constructor() { }

    /** モード情報 */
    private mode: number;
    /** Homeでのカテゴリ情報の質問情報 */
    private categoryInfo: any;
    /** メインの質問情報 */
    private questionList: any;
    /** メインの回答情報 */
    private resultList: any;
    /** 基本情報の質問情報 */
    private startQuestionList: any;
    /** DB取得時の基本情報の質問情報 */
    private initialStartQuestionList: any;
    /** 基本情報の回答情報 */
    private startResultList: any;
    /** 特建）検査項目情報 */
    private inspectionList: any;
    /** エラーリスト */
    private errorList: any[];
    /** 回答者情報 */
    private answerUserInfo: any;
    /** 問診回答設定情報 */
    private settingMonsinInfo:any;

    /** 
     * 一括ですべての保持データを初期化
     */
    refleshAll(): void {
        this.refleshModeShare();
        this.refleshCategoryInfoShare();
        this.refleshQuestionListShare();
        this.refleshResultListShare();
        this.refleshStartQuestionListShare();
        this.refleshStartResultListShare();
        this.refleshInspectionListShare();
        this.refleshErrorListShare();
        this.refleshSettingMonsinInfo();
    }

    /** モード情報設定 */
    setModeShare(mode: number): void {
        //リクエストパラメータセット
        this.mode = mode;
    }
    /** モード情報取得 */
    getModeShare(): number {
        return this.mode;
    }
    /** モード情報リフレッシュ */
    refleshModeShare(): void {
        this.mode = null;
    }

    /** Homeでのカテゴリ情報の質問情報設定 */
    setCategoryInfoShare(categoryInfo: any): void {
        this.categoryInfo = categoryInfo;
    }
    /** Homeでのカテゴリ情報の質問情報取得 */
    getCategoryInfoShare(): any {
        return this.categoryInfo;
    }
    /** Homeでのカテゴリ情報の質問情報リフレッシュ */
    refleshCategoryInfoShare(): void {
        this.categoryInfo = null;
    }

    /** メインの質問情報設定 */
    setQuestionListShare(qurstionList: any): void {
        this.questionList = qurstionList;
    }
    /** メインの質問情報取得 */
    getQuestionListShare(): any {
        return this.questionList;
    }
    /** メインの質問情報リフレッシュ */
    refleshQuestionListShare(): void {
        this.questionList = null;
    }

    /** メインの回答情報設定 */
    setResultListShare(resultList: any): void {
        this.resultList = resultList;
    }
    /** メインの回答情報取得 */
    getResultListShare(): any {
        return this.resultList;
    }
    /** メインの回答情報リフレッシュ */
    refleshResultListShare(): void {
        this.resultList = null;
    }

    /** 基本情報の質問情報設定 */
    setStartQuestionListShare(startQuestionList: any): void {
        this.startQuestionList = startQuestionList;
    }
    /** 基本情報の質問情報取得 */
    getStartQuestionListShare(): any {
        return this.startQuestionList;
    }
    /** 基本情報の質問情報リフレッシュ */
    refleshStartQuestionListShare(): void {
        this.startQuestionList = null;
    }
    
    /** DB取得時の基本情報の質問情報設定 */
    setInitialStartQuestionListShare(initialStartQuestionList: any): void {
        this.initialStartQuestionList = initialStartQuestionList;
    }
    /** DB取得時の基本情報の質問情報取得 */
    getInitialStartQuestionListShare(): any {
        return this.initialStartQuestionList;
    }
    /** DB取得時の基本情報の質問情報リフレッシュ */
    refleshInitialStartQuestionListShare(): void {
        this.initialStartQuestionList = null;
    }

    /** 基本情報の回答情報設定 */
    setStartResultListShare(startResultList: any): void {
        //リクエストパラメータセット
        this.startResultList = startResultList;
    }
    /** 基本情報の回答情報取得 */
    getStartResultListShare(): any {
        return this.startResultList;
    }
    /** 基本情報の回答情報リフレッシュ */
    refleshStartResultListShare(): void {
        this.startResultList = null;
    }

    /** 検査項目情報設定 */
    setInspectionListShare(inspectionList: any): void {
        this.inspectionList = inspectionList;
    }
    /** 検査項目情報取得 */
    getInspectionListShare(): any {
        return this.inspectionList;
    }
    /** 検査項目情報リフレッシュ */
    refleshInspectionListShare(): void {
        this.inspectionList = null;
    }
    
    /** エラーリスト設定 */
    setErrorListShare(errorList: any[]): void {
        //リクエストパラメータセット
        this.errorList = errorList;
    }
    /** エラーリスト取得 */
    getErrorListShare(): any[] {
        return this.errorList;
    }
    /** エラーリストリフレッシュ */
    refleshErrorListShare(): void {
        this.errorList = null;
    }
    /** エラー情報を追加 */
    pushErrorListShare(error: any): void {
        if (!this.errorList) this.errorList = [];
        this.errorList.push(error);
    }

    /** 回答者情報 */
    setAnswerUserInfo(answerUserInfo: any): void {
        //リクエストパラメータセット
        this.answerUserInfo = answerUserInfo;
    }
    /** 基本情報の回答情報取得 */
    getAnswerUserInfo(): any {
        return this.answerUserInfo;
    }
    /** 基本情報の回答情報リフレッシュ */
    refleshAnswerUserInfo(): void {
        this.answerUserInfo = null;
    }

    /** 問診回答設定情報 */
    setSettingMonsinInfo(settingMonsinInfo: any): void {
        //リクエストパラメータセット
        this.settingMonsinInfo = settingMonsinInfo;
    }
    /** 問診回答設定情報取得 */
    getSettingMonsinInfo(): any {
        return this.settingMonsinInfo;
    }
    /** 問診回答設定情報リフレッシュ */
    refleshSettingMonsinInfo(): void {
        this.settingMonsinInfo = {
            'has_SPError':false,
            'chemical_alldisp':false,
            'organic_alldisp':false
        };
    }

    checkSPPreviousError(checklist:any):boolean{
        let ret = false;
        for (let i in checklist.t_result_list.t_result_id_list) {
            var row = checklist.m_answer_list.filter(
                item => 
                    item.hidden_flg == 1
                    && item.m_answer_id == checklist.t_result_list.t_result_id_list[i]
              );
            if(row.length>0){
                //1つでもあれば決定
                return true;
            }
        }
        return ret;
    }
}


// WEBPACK FOOTER //
// ./src/app/service/share.service.ts